import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { useDeleteOrgProduct, useEditOrgProducts } from "src/services/admin/commands/clients";
import { useGetClientDetailRequest } from "src/services/admin/queries/clients";

import Context from "../context";

export const useGetClientDetailData = () => {
	const { state } = useContext(Context);

	const clientId = state.client?.id ?? "";
	const queryKey = ["clients", clientId];

	useGetClientDetailRequest(clientId);
	const { mutate } = useEditOrgProducts();
	const { mutate: mutateDelete } = useDeleteOrgProduct();

	const queryClient = useQueryClient();
	const { data } = useQuery<string[]>({
		queryKey
	});

	const onChangeValue = (value: string) => {
		if (data && !data.find((i) => i === value)) {
			const newProducts = [...data, value];
			queryClient.setQueryData(queryKey, newProducts);
			mutate({ orgId: clientId, products: newProducts });
		} else if (data) {
			queryClient.setQueryData(
				queryKey,
				data.filter((i) => i !== value)
			);
			mutateDelete({ orgId: clientId, productId: value });
		}
	};

	return { data, onChangeValue };
};
